<template>
  <div class="col-md-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-md-6 d-flex">
          <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
            <li class="nav-item" v-for="(item, index) in tab" :key="index">
              <a
                class="nav-link"
                :class="{ active: item.active }"
                id="top-home-tab"
                data-bs-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="top-home"
                :aria-selected="item.active ? 'true' : 'false'"
                @click.prevent="active(item)"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-0 me-0"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <div class="tab-content" id="top-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'active show': item.active }"
            :id="item.id"
            role="tabpanel"
            :aria-labelledby="item.label"
            v-for="(item, index) in tab"
            :key="index"
          >
            <component
              :is="item.type"
              :tickets="getTicketsForTab(item.type)"
              :loading="loading"
              @ticket-created="handleTicketCreated"
              @ticket-updated="handleTicketUpdated"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/includes/connection";
import Registered from "./Registered.vue";
import Active from "./Active.vue";
import Concluded from "./Concluded.vue";

export default {
  name: "topMenu",
  components: {
    Registered,
    Active,
    Concluded,
  },
  data() {
    return {
      tab: [
        {
          type: "Registered",
          name: "Recibidos",
          active: true,
          icon: "target",
          id: "top-home",
          id1: "top-registered-tabContent",
          label: "",
        },
        {
          type: "Active",
          name: "Activos",
          active: false,
          icon: "target",
          id: "top-active",
          id1: "top-active-tabContent",
          label: "",
        },
        {
          type: "Concluded",
          name: "Concluidos",
          active: false,
          icon: "target",
          id: "top-concluded",
          id1: "top-concluded-tabContent",
          label: "",
        },
      ],
      allTickets: [],
      loading: false,
    };
  },
  computed: {
    currentUserId() {
      try {
        const user = JSON.parse(localStorage.getItem("User"));
        return user?.id || null;
      } catch (error) {
        console.error("Error getting user:", error);
        return null;
      }
    },
  },
  methods: {
    active(item) {
      if (!item.active) {
        this.tab.forEach((a) => {
          a.active = false;
        });
      }
      item.active = !item.active;
    },

    async loadTickets() {
      this.loading = true;
      try {
        const response = await axios.get("/ticket");
        if (response.data) {
          this.allTickets = response.data;
        }
      } catch (error) {
        console.error("Error loading tickets:", error);
      } finally {
        this.loading = false;
      }
    },

    getTicketsForTab(tabType) {
      if (!this.currentUserId) return [];

      switch (tabType) {
        case "Registered":
          return this.allTickets.filter(
            (ticket) =>
              ticket.user_id === this.currentUserId &&
              ticket.status === "ACTIVO"
          );

        case "Active":
          return this.allTickets.filter((ticket) => ticket.status === "ACTIVO");

        case "Concluded":
          return this.allTickets.filter((ticket) =>
            ["RESUELTO", "CANCELADO"].includes(ticket.status)
          );

        default:
          return [];
      }
    },

    getTabCount(tabType) {
      return this.getTicketsForTab(tabType).length;
    },

    handleTicketCreated(newTicket) {
      this.loadTickets();
    },

    handleTicketUpdated(updatedTicket) {
      this.loadTickets();
    },
  },
  mounted() {
    this.loadTickets();
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.7em;
  padding: 0.25em 0.5em;
}
</style>
